<template>
  <div class="AutoscalingWarningSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="searchCompany"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="3">
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          @on-change="searchAccountType()"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          search
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil";
import {
  CLOUD_PLATFORM_ID,
  buildPlatformOptions
} from "../../../utils/cloudPlatform.js";
export default {
  name: "AutoscalingWarningSearch",
  data() {
    return {
      modal_loading: false,
      tag: "",
      region: [],
      instanceId: "",
      regionList: [],
      regionName: "",
      instanceName: "",
      accountName: "",
      accountType: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: buildPlatformOptions([
        CLOUD_PLATFORM_ID.AWS,
        CLOUD_PLATFORM_ID.ALIYUN,
        CLOUD_PLATFORM_ID.AZURE,
        CLOUD_PLATFORM_ID.VMWARE,
        CLOUD_PLATFORM_ID.GCP,
      ]),
    };
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function () {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then((res) => {
          this.companyList = res.data;
        });
    },
    // 按公司搜索
    searchCompany: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("companyId", this.companyId);
      this.$parent.methods.showAll();
    },
    // 按账户类型筛选
    searchAccountType: function () {
      eventBus.$emit("accountType", this.accountType);
      this.$parent.showAll();
    },
    // 按账户名称搜索
    searchAccountName: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("accountName", this.accountName);
      this.$parent.methods.showAll();
    },
  },
};
</script>
<style scoped>
.AutoscalingWarningSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/autoscaling/AutoscalingWarningSearch.vue